<div class="h-full w-full flex flex-col items-center justify-start overflow-hidden">
    <div class="w-full space-y-2 p-2 h-full overflow-y-auto scrollbar-transparent">

         <!-- Viewer Genders Card -->
         <div class="tto-reporting-card p-4">
            <!-- Header -->
            <div class="flex flex-col gap-y-0.5 mb-4">
                <div class="flex items-center gap-x-1.5">
                    <h3 class="text-sm font-semibold text-foreground">Genders</h3>
                    <button type="button"
                        class="text-muted-foreground hover:text-foreground transition-colors focus-visible:outline-none"
                        aria-label="Traffic sources information">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="size-4"
                            aria-hidden="true">
                            <circle cx="12" cy="12" r="10" />
                            <path d="M12 16v-4M12 8h.01" />
                        </svg>
                    </button>
                </div>
                <p class="text-xs text-muted-foreground">What is the gender distribution of your viewers?</p>
            </div>
            <!-- Header - END -->

            @if (genderRows().length === 0) {
                <p class="text-xs text-muted-foreground text-center py-4">No gender data available.</p>
            } @else {
                <!-- Semicircle chart -->
                <div echarts [options]="genderChartOption()" [autoResize]="true"
                    class="w-full h-40"
                    aria-label="Gender distribution semicircle chart">
                </div>

                <!-- Legend rows -->
                <div class="divide-y divide-border mt-2">
                    @for (row of genderRows(); track row.label) {
                        <div class="flex items-center justify-between py-3">
                            <div class="flex items-center gap-x-2.5">
                                <span class="size-2.5 rounded-full flex-shrink-0"
                                    [style.background-color]="row.color">
                                </span>
                                <span class="text-sm text-foreground">{{ row.label }}</span>
                            </div>
                            <span class="text-sm font-semibold text-foreground tabular-nums">{{ row.percentage }}</span>
                        </div>
                    }
                </div>
            }
        </div>
        <!-- Viewer Genders Card - END -->


        <!-- Viewer Age Groups Card -->
        <div class="tto-reporting-card p-4">
            <!-- Header -->
            <div class="flex flex-col gap-y-0.5 mb-4">
                <div class="flex items-center gap-x-1.5">
                    <h3 class="text-sm font-semibold text-foreground">Age groups</h3>
                    <button type="button"
                        class="text-muted-foreground hover:text-foreground transition-colors focus-visible:outline-none"
                        aria-label="Age groups information">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="size-4"
                            aria-hidden="true">
                            <circle cx="12" cy="12" r="10" />
                            <path d="M12 16v-4M12 8h.01" />
                        </svg>
                    </button>
                </div>
                <p class="text-xs text-muted-foreground">What is the age distribution of your viewers?</p>
            </div>
            <!-- Header - END -->

            <div class="space-y-3">
                @if (ageGroups().length === 0) {
                    <p class="text-xs text-muted-foreground text-center py-4">No age group data available.</p>
                } @else {
                    @for (source of ageGroups(); track source.label) {
                        <div>
                            <div class="flex items-center justify-between mb-1.5">
                                <span class="text-sm text-foreground">{{ source.label }}</span>
                                <span class="text-sm font-semibold text-foreground tabular-nums">{{ source.percentage }}</span>
                            </div>
                            <div class="h-2 w-full rounded-full bg-muted overflow-hidden">
                                <div class="h-full rounded-full traffic-bar"
                                    [style.width]="source.widthPct + '%'">
                                </div>
                            </div>
                        </div>
                    }
                }
            </div>
        </div>
        <!-- Viewer Age Groups Card - END -->


        <!-- Viewer Locations Card -->
        <div class="tto-reporting-card p-4">
            <!-- Header -->
            <div class="flex flex-col gap-y-0.5 mb-4">
                <div class="flex items-center gap-x-1.5">
                    <h3 class="text-sm font-semibold text-foreground">Locations</h3>
                    <button type="button"
                        class="text-muted-foreground hover:text-foreground transition-colors focus-visible:outline-none"
                        aria-label="Locations information">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" class="size-4"
                            aria-hidden="true">
                            <circle cx="12" cy="12" r="10" />
                            <path d="M12 16v-4M12 8h.01" />
                        </svg>
                    </button>
                </div>
                <p class="text-xs text-muted-foreground">Where are your viewers located?</p>
            </div>
            <!-- Header - END -->

            <div class="space-y-3">
                @if (locations().length === 0) {
                    <p class="text-xs text-muted-foreground text-center py-4">No location data available.</p>
                } @else {
                    @for (location of locations(); track location.label) {
                        <div>
                            <div class="flex items-center justify-between mb-1.5">
                                <span class="text-sm text-foreground">{{ location.label }}</span>
                                <span class="text-sm font-semibold text-foreground tabular-nums">{{ location.percentage }}</span>
                            </div>
                            <div class="h-2 w-full rounded-full bg-muted overflow-hidden">
                                <div class="h-full rounded-full traffic-bar"
                                    [style.width]="location.widthPct + '%'">
                                </div>
                            </div>
                        </div>
                    }
                }
            </div>
        </div>
        <!-- Viewer Locations Card - END -->


    </div>
</div>